import { useEffect } from 'react';
import { useCustom } from '@refinedev/core';

/**
 * Результат /files/:id/info (подмножество нужных полей).
 */
export interface FileInfo {
  id: number;
  url: string;
  originalName: string;
  mimeType: string;
}

/**
 * Подтянуть info о файле по id. Используется в формах чтобы получить url
 * по уже сохранённому fileId (backend DTO эфира отдаёт только thumbnailFileId).
 */
export function useFileInfo(fileId: number | null, onLoaded: (info: FileInfo | null) => void): void {
  const { result } = useCustom<FileInfo>({
    url: `/files/${fileId}/info`,
    method: 'get',
    queryOptions: {
      enabled: fileId !== null && fileId > 0,
      staleTime: 60_000,
    },
  });

  useEffect(() => {
    if (!fileId) {
      onLoaded(null);
      return;
    }
    const data = result?.data;
    if (data && typeof data.url === 'string') {
      onLoaded({
        id: data.id,
        url: data.url,
        originalName: data.originalName,
        mimeType: data.mimeType,
      });
    }
    // onLoaded должен быть стабильной ссылкой (useCallback в parent при необходимости).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileId, result?.data]);
}
